export type FolderNavigationItem = {
  active: boolean;
  href: string;
  label: string;
};

export type FolderNavigationMainItem = FolderNavigationItem & {
  items?: Array<FolderNavigationItem>;
};

export type FolderNavigationProps = {
  mainItems?: Array<FolderNavigationMainItem>;
  items?: Array<FolderNavigationItem>;
  title?: string;
};
